import { UUID } from "io-ts-types/lib/UUID"
import { useEffect } from "react"
import { useInternalFlags } from "./useInternalFlags"

export const useDemoModeFromQueryString = (userId?: UUID): void => {
  const { flags, setFlags } = useInternalFlags(userId)

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const demoModeParam = searchParams.get(`demoMode`)
    const isDemoModeEnabled = demoModeParam === `true`

    if (flags.isDemoModeEnabled !== isDemoModeEnabled) {
      setFlags({ isDemoModeEnabled })
    }
  }, [flags.isDemoModeEnabled, setFlags])
}
